
import UISelect from "@/components/UI/UiSelect.vue";
export default {
  components: {
    UISelect,
  },
  props: {
    value: {
      type: [String, Object],
      default: "",
    },
    items: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
  },
  methods: {
    onFilterClick(data) {
      this.$emit(
        "onFilterClick",
        this.items.find((el) => el.slug === data)
      );
    },
  },
};
